// extracted by mini-css-extract-plugin
export default {"large":"LikeFullIconButton_large__CF9e4","container":"LikeFullIconButton_container__RlCcE","love-appear":"LikeFullIconButton_love-appear__qI2cA"};